/**
 * Wann steht eine Reflexion aus? (F-40) - eine Regel fuer die Uebersicht und
 * die Glocke, rein und getestet. Vorher meldete die Uebersicht schon ab
 * Freitag bzw. drei Tage vor Monatsende, die Glocke erst ab Sonntag.
 *
 * - Woche: ab dem Rueckblick-Tag (Standard Sonntag) und an den zwei Tagen
 *   danach. Ein Rueckblick-Tag von Freitag bis Sonntag gilt der laufenden
 *   Woche, Montag bis Donnerstag der Woche davor - sie ist gerade zu Ende.
 * - Monat: ab dem Monatsletzten und an den zwei Tagen danach.
 */
import { addDays, endOfMonth, isoWeekKey, weekday } from '@/lib/datetime';
import type { LocalDate } from '@/domain/types';

/** 0 = Sonntag ... 6 = Samstag, wie `weekday()`. */
export const STANDARD_RUECKBLICK_TAG = 0;
/** So viele Tage nach dem Stichtag bleibt der Hinweis stehen. */
export const NACHLAUF_TAGE = 2;

export const WOCHENTAG_NAMEN = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'] as const;

export function rueckblickTagAus(roh: unknown): number {
  return typeof roh === 'number' && Number.isInteger(roh) && roh >= 0 && roh <= 6 ? roh : STANDARD_RUECKBLICK_TAG;
}

/** Die ISO-Woche (`'2026-W40'`), deren Reflexion an `heute` ansteht - sonst `null`. */
export function faelligeWoche(heute: LocalDate, rueckblickTag = STANDARD_RUECKBLICK_TAG): string | null {
  for (let i = 0; i <= NACHLAUF_TAGE; i++) {
    const stichtag = addDays(heute, -i);
    if (weekday(stichtag) !== rueckblickTag) continue;
    const vorwoche = rueckblickTag >= 1 && rueckblickTag <= 4;
    return isoWeekKey(vorwoche ? addDays(stichtag, -7) : stichtag);
  }
  return null;
}

/** Der Monat (`'2026-09'`), dessen Reflexion an `heute` ansteht - sonst `null`. */
export function faelligerMonat(heute: LocalDate): string | null {
  for (let i = 0; i <= NACHLAUF_TAGE; i++) {
    const tag = addDays(heute, -i);
    if (tag === endOfMonth(tag)) return tag.slice(0, 7);
  }
  return null;
}
